import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {SuppliersService} from '../../../services/suppliers.service';
import {combineLatest, iif, Observable, of} from 'rxjs';
import {FileResponse} from '../../../models/file.response';
import {saveAs} from 'file-saver';
import {debounceTime, exhaustMap, startWith, tap} from 'rxjs/operators';
import {FormControl} from '@angular/forms';
import {DocumentService, ImageService, OrdersService, ProleisObject} from "@proleis/proleis-rest-client";
import {CurrentViewService} from "@proleis/proleis-web-app";

@Component({
  selector: 'ps-eta-documents',
  templateUrl: 'eta.documents.component.html'
})
export class EtaDocumentsComponent implements OnInit {
  searchFormControl: FormControl;

  pbo$: Observable<ProleisObject | null>;
  pboStatusIcons: Map<string, string>;
  pos$: Observable<ProleisObject | null>;
  etaDocuments$: Observable<ProleisObject[] | null>;
  filter$: Observable<string>;

  constructor(private activatedRoute: ActivatedRoute, private suppliersService: SuppliersService, private imageService: ImageService,
              private currentViewService: CurrentViewService, private documentsService: DocumentService,
              private ordersService: OrdersService) {
  }

  ngOnInit() {
    this.searchFormControl = new FormControl();

    const params = this.activatedRoute.snapshot.params;
    const aliasFields = 'LIEFERANT=FIRMA_ID.NAME;LIEFERSTATUS=FREIGABE_ID.DESCRIPTION;LIEFERSTATUS_ICON=FREIGABE_ID.ICON;' +
      'PROJEKTNAME=LINK_ID.PARENTANDMYSELF[TYP_ID.GUID=b514d7ec-27fa-11b2-800a-b390cd5bbe84].TEXT';
    this.pbo$ = this.ordersService.getPurchaseOrder(params.id, aliasFields);

    this.pbo$.subscribe(pbo => {
      this.imageService.getIconUrls(pbo.LIEFERSTATUS_ICON).subscribe(icons => {
        this.pboStatusIcons = icons;
      });
    });

    this.pos$ = this.suppliersService.getPosition(params.id, params.posId);
    this.filter$ = this.filter();
    this.etaDocuments$ = this.suppliersService.getEtaDocuments(params.id, params.posId);
    this.etaDocuments$ = combineLatest(
      [this.etaDocuments$, this.filter$]
    ).pipe(
      exhaustMap(([etaDocuments, filterExpression]) => {
        return iif(() => filterExpression === '',
          of(etaDocuments),
          of(etaDocuments.filter(doc => doc.NAME.toLowerCase().includes(filterExpression.toLowerCase()))));
      }),
      tap(result => this.currentViewService.setLoading(false))
    );
  }

  downloadDocument(docId: string) {
    return this.documentsService.getDocumentFile(docId).subscribe(response => {
        const fileResponse: FileResponse = FileResponse.parseResponse(response);
        saveAs(fileResponse.content, fileResponse.fileName);
        this.currentViewService.setLoading(false);
      }
    );
  }

  filter(): Observable<string> {
    return this.searchFormControl.valueChanges.pipe(
      tap(value => this.currentViewService.setLoading(true)),
      debounceTime(250),
      startWith('')
    );
  }

}
